export function otpRetryAfter(value) {
  var seconds = Number(value);
  if (!Number.isFinite(seconds) || seconds <= 0) return 30;
  return Math.min(30, Math.max(1, Math.ceil(seconds)));
}

function resendButtonUsesGrayDisabledStyle(button) {
  return button && button.classList.contains('timetable-modal-btn-blue');
}

function setResendButtonWaiting(button, waiting) {
  if (!button) return;
  if (waiting) {
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    if (!resendButtonUsesGrayDisabledStyle(button)) {
      button.classList.add('opacity-70');
    }
  } else {
    button.disabled = false;
    button.removeAttribute('aria-disabled');
    button.classList.remove('opacity-70');
  }
}

export function startOtpResendCooldown(opts) {
  opts = opts || {};
  var button = opts.button;
  var countdownEl = opts.countdownEl;
  var seconds = otpRetryAfter(opts.seconds);
  var deadline = Date.now() + seconds * 1000;

  if (button && button.__otpCooldownTimer) {
    window.clearInterval(button.__otpCooldownTimer);
  }

  function render() {
    var remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
    if (remaining <= 0) {
      if (button) {
        window.clearInterval(button.__otpCooldownTimer);
        button.__otpCooldownTimer = null;
        setResendButtonWaiting(button, false);
      }
      if (countdownEl) {
        countdownEl.textContent = '';
        countdownEl.classList.add('hidden');
      }
      return;
    }
    if (button) {
      setResendButtonWaiting(button, true);
    }
    if (countdownEl) {
      countdownEl.textContent = 'Resend code in ' + remaining + 's';
      countdownEl.classList.remove('hidden');
    }
  }

  render();
  if (button) {
    button.__otpCooldownTimer = window.setInterval(render, 250);
  }
}

export function stopOtpResendCooldown(button, countdownEl) {
  if (button && button.__otpCooldownTimer) {
    window.clearInterval(button.__otpCooldownTimer);
    button.__otpCooldownTimer = null;
  }
  if (button) {
    setResendButtonWaiting(button, false);
  }
  if (countdownEl) {
    countdownEl.textContent = '';
    countdownEl.classList.add('hidden');
  }
}
